"use client";

import { createContext, useContext, type ReactNode } from "react";
import { usePathname } from "next/navigation";

type ProductHubInfo = {
  /** Letztes Segment der URL, z. B. "mylife-loop". Schluessel fuer Tracking und Reporting. */
  slug: string;
  name: string;
  company: string;
};

const ProductHubContext = createContext<ProductHubInfo | null>(null);

/**
 * Macht den Hub fuer alle Bloecke darin sichtbar, damit Views und Klicks dem
 * richtigen Hub und Unternehmen zugeordnet werden koennen. Ausserhalb eines
 * Hubs liefert `useProductHub()` `null`.
 *
 * Der Slug kommt aus der URL: `StoryblokStory` reicht nur `content` an die
 * Komponente weiter, nicht die Story selbst.
 */
const ProductHubProvider = ({
  name,
  company,
  children,
}: {
  name: string;
  company: string;
  children: ReactNode;
}) => {
  const pathname = usePathname();
  const slug = pathname.split("/").filter(Boolean).pop() ?? "";

  return (
    <ProductHubContext.Provider value={{ slug, name, company }}>{children}</ProductHubContext.Provider>
  );
};

const useProductHub = () => useContext(ProductHubContext);

export { ProductHubProvider, useProductHub };
